<template lang="pug">
div(class='bg-gray-lighter pb-10 lg:pb-0')
  div(class='lg:border lg:mt-5 lg:bg-white')
    div(class='text-center text-lg font-bold color-dark py-3 uppercase whitespace-nowrap lg:bg-gray-lightest')
      | Need Help?
      span(class='block ml-1 lg:inline-block') Give us a call #[UniversalLink(link='PHONE' class='text-gray-darkest hover:underline') {{ $sitewideConfig.config.phoneGeneral }}]

    div(class='p-3 lg:bg-white')
      div(class='text-gray-dark text-xs text-center uppercase font-bold whitespace-pre lg:flex lg:justify-around xl:text-sm')
        figure(class='flex justify-center items-center lg:w-1/3')
          img(src='/images/shield.svg' alt='shield' class='w-10 h-10' loading='lazy')
          figcaption(class='shrink-0 p-3')
            span Guaranteed
              br
              | Best Price

        figure(class='flex justify-center items-center lg:w-1/3')
          img(src='/images/tools.svg' alt='tools' class='w-10 h-10' loading='lazy')
          figcaption(class='shrink-0 p-3')
            template(v-if='$device.isMobile')
              | Lifetime
              br
              | Install
              br
              | Support
            template(v-else)
              | Lifetime
              br
              | Install Support

        figure(class='flex justify-center items-center lg:w-1/3')
          img(src='/images/deliveryTruck.svg' alt='delivery truck' class='w-12 h-10' loading='lazy')
          figcaption(class='shrink-0 p-3')
            | Fastest
            br
            | Shipping

  div(class='text-center mt-5')
    img(src='/images/visa.svg' alt='visa' class='mr-3 w-8 h-5' loading='lazy')
    img(src='/images/mastercard.svg' alt='mastercard' class='mr-3 w-8 h-5' loading='lazy')
    img(src='/images/discover.svg' alt='discover' class='mr-3 w-8 h-5' loading='lazy')
    img(src='/images/amex.svg' alt='american express' class='w-8 h-5' loading='lazy')
</template>

<script lang="ts" setup>
const { $sitewideConfig, $device, $invoca } = useNuxtApp()
const { isIntegrationEnabled } = useUtils()

onMounted(() => {
  if (isIntegrationEnabled('invoca')) $invoca.changePhone()
})
</script>
